import { useQuery } from "@tanstack/react-query";
import { getLatestBlogPosts } from "api/blog-services.request";

interface BlogPost {
  title: string;
  url: string;
  image: string;
  excerpt: string;
}

export default function useBlogPosts() {
  return useQuery(["latestBlogPosts"], () => getLatestBlogPosts(), {
    cacheTime: 5 * 60 * 1000, // 5 minutes
    staleTime: 2 * 60 * 1000, // 2 minutes
    select: (response) => response.data as BlogPost[],
  });
} 